module.exports = __webpack_public_path__ + "img/btn.249be74a.png";